import "./homeTemplate.scss";
import HomeCircle from "../../organisms/homeCircle/homeCircle";
import imgSrc from "../../../bgImages/home.JPG";
//SizeType puede ser 1, 2, 3, 4...
//type puede ser h -> h1 h2, etc o p -> párrafo
//fontWeight puede ser 100, 200, 300 o 400.
const HomeTemplate = ({ data }) => {
  return (
    <div className="home-template__main-container">
      <HomeCircle imgSrc={imgSrc} data={data} />
    </div>
  );
};

export default HomeTemplate;
